"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestGenerator = requestGenerator;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _compose = _interopRequireDefault(require("ramda/src/compose"));

var _merge = _interopRequireDefault(require("ramda/src/merge"));

var _actionHelpers = require("../actionHelpers");

var _doAction = require("./doAction");

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(requestGenerator);

function requestGenerator(actionFn, action) {
  var response, lastSucceedAt;
  return _regenerator["default"].wrap(function requestGenerator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          actionFn = (0, _compose["default"])((0, _merge["default"])({
            requestAction: action
          }), actionFn);
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.put)((0, _actionHelpers.asRequest)(actionFn(null)));

        case 4:
          return _context.delegateYield((0, _doAction.doAction)(action), "t0", 5);

        case 5:
          response = _context.t0;
          lastSucceedAt = new Date().toISOString();
          _context.next = 9;
          return (0, _effects.put)((0, _actionHelpers.asSuccess)(actionFn(response, {
            lastSucceedAt: lastSucceedAt
          })));

        case 9:
          return _context.abrupt("return", {
            response: response
          });

        case 12:
          _context.prev = 12;
          _context.t1 = _context["catch"](1);
          _context.next = 16;
          return (0, _effects.put)((0, _actionHelpers.asError)(actionFn(_context.t1)));

        case 16:
          return _context.abrupt("return", {
            error: _context.t1
          });

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 12]]);
}